import { RestClient } from '@/api/rest-client'
import { Pipeline } from '@/api/model/pipeline'
import { Company } from '@/api/model/company'
import { cloneDeep } from 'lodash'
import { Branch } from '@/api/model/branch'
import { CompanyAPI } from '@/api/backend-client'

export class PipelineClient extends RestClient<Pipeline> {
    collectionName = 'pipelines'
    parseData = Pipeline.fromData

    async create(data: Pipeline): Promise<Pipeline> {
        const request = cloneDeep<any>(data)

        if (data.company instanceof Company) {
            request.company = data.company.resourceIdentifier
        }

        if (data.fallbackBranch instanceof Branch) {
            request.fallbackBranch = data.fallbackBranch.resourceIdentifier
        }

        if (data.branches) {
            request.branches = data.branches
                .filter((branch: Branch) => branch instanceof Branch)
                .map((branch: Branch) => branch.resourceIdentifier)
        }

        if (data.linkedBranches) {
            request.linkedBranches = data.linkedBranches.map(linkedBranch => ({
                branchId: linkedBranch.branch.id,
                potentialOrderValuePerReferral: linkedBranch.potentialOrderValuePerReferral,
            }))
        }

        return super.create(request)
    }

    async update(id: string, data: Pipeline): Promise<Pipeline> {
        const request = cloneDeep<any>(data)

        if (data.company) {
            delete request.company
        }

        if (data.fallbackBranch instanceof Branch) {
            request.fallbackBranch = data.fallbackBranch.resourceIdentifier
        }

        if (data.branches) {
            request.branches = data.branches
                .filter((branch: Branch) => branch instanceof Branch)
                .map((branch: Branch) => branch.resourceIdentifier)
        }

        if (data.linkedBranches) {
            request.linkedBranches = data.linkedBranches.map(linkedBranch => ({
                branchId: linkedBranch.branch.id,
                potentialOrderValuePerReferral: linkedBranch.potentialOrderValuePerReferral,
            }))
        }

        return super.update(id, request)
    }

    async getOwnPipelines(): Promise<Pipeline[]> {
        if (!this.decodedAccessToken) {
            return []
        }

        try {
            const response = await this.client.get(`${this.basePath}/${this.collectionName}?company=${this.decodedAccessToken.companyId}`)
            const collection = response.data['hydra:member'] as any[]
            return collection.map(value => this.parseData({
                ...value,
                company: CompanyAPI.currentCompany,
            }))

        } catch (error) {
            this.handleError(error)
        }
    }

    protected handleError(error: any) {
        throw error
    }
}
